export class SavedObjectRequestModel {
    constructor(values) {
        Object.assign(this, values);
    }
    name;
    description;
    url;
    isFavorite = false;
    type = 'search';
    id;
    osdData;
}
export class SavedObjectOsdData {
    hits;
    columns;
    sort;
    exploreFilterState;
    excludedAccounts;
}
export class SavedObjectModel {
    id;
    userId;
    createdAt;
    updatedAt;
    createdBy;
    updatedBy;
    name;
    description;
    isFavorite = false;
    url;
    type;
    osdData;
}
//# sourceMappingURL=saved-objects.js.map